import * as React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { getStoredThemeMode, applyThemeMode } from 'apps/utils/themeMode'
import 'styles/base.scss'

// Apply the persisted light/dark mode before the first paint so a dark
// user doesn't get a white flash.
applyThemeMode( getStoredThemeMode() )

ReactDOM.render(
	<App />,
	document.querySelector( '#root' ),
)
